import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import api from "@/lib/api";

const KIND = { invoice: "Invoice", invoice_reminder: "Reminder", auto_reminder: "Auto reminder" };

export const InvoiceEmailHistory = ({ invoiceId, refreshKey }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!invoiceId) { return; }
    api.get(`/sales/invoices/${invoiceId}/email-history`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [invoiceId, refreshKey]);
  return (
    <div className="px-4 md:px-6 py-4 border-t" data-testid="invoice-email-history">
      <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground mb-2 flex items-center gap-1.5">
        <Mail className="w-3 h-3" /> Email history
      </div>
      {rows.length === 0 ? (
        <div className="text-xs text-muted-foreground" data-testid="email-history-empty">Not emailed yet.</div>
      ) : (
        <div className="space-y-2">
          {rows.map((r, i) => (
            <div key={i} className="text-xs border rounded-sm p-2" data-testid={`email-history-row-${i}`}>
              <div className="flex justify-between gap-2">
                <span className="font-medium">{KIND[r.kind] || r.kind}{r.milestone_days ? ` \u00b7 ${r.milestone_days}d overdue` : ""}</span>
                <span className="text-muted-foreground">{new Date(r.created_at).toLocaleString("en-IN")}</span>
              </div>
              <div><span className="text-muted-foreground">To:</span> {r.to}</div>
              {r.cc?.length > 0 && <div><span className="text-muted-foreground">CC:</span> {r.cc.join(", ")}</div>}
              {r.bcc?.length > 0 && <div><span className="text-muted-foreground">BCC:</span> {r.bcc.join(", ")}</div>}
              <div className={r.status === "sent" ? "text-emerald-600" : "text-red-600"}>
                {r.status}{r.error ? ` \u2014 ${r.error}` : ""}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
